// Exported utilities, useful for @daimo/pay users.
import packageJson from "../../package.json";

export const daimoPayVersion = packageJson.version;
